import {
  ChannelTypeEnum,
  SendingStatus,
  WhatsAppContact,
  WhatsAppConversationDataType,
  WhatsAppMessageType,
} from "../..";
import {
  WhatsAppErrorData,
  WhatsAppLoginSuccessData,
  WhatsAppReceiveLoginQRCodeData,
  WhatsAppUnreadNumUpdateData,
  WHATSAPP_WS_RESPONSE_TYPE,
} from "./ws-types";
import chatSdkHooks from "../../hooks";
import { WSResponseData } from "../../request/ws";

const waitingWorks = [] as WSResponseData[];

function handlePushWaitWorks(data: WSResponseData) {
  waitingWorks.push(data);
}
export function wsHandler(data: WSResponseData) {
  if (data.type) {
    handlePushWaitWorks(data);
  }
}

// @ts-ignore
window.requestIdleCallback =
  window.requestIdleCallback ||
  function (cb) {
    const start = Date.now();
    return setTimeout(function () {
      cb({
        didTimeout: false,
        timeRemaining: function () {
          return Math.max(0, 50 - (Date.now() - start));
        },
      });
    }, 1);
  };

window.cancelIdleCallback =
  window.cancelIdleCallback ||
  function (id) {
    clearTimeout(id);
  };

function handlePopWaitWorks() {
  window.requestIdleCallback(
    () => {
      const work = waitingWorks.shift();
      if (work) {
        const { data, type, user_id, client_id, ip } = work;
        switch (type) {
          case WHATSAPP_WS_RESPONSE_TYPE.RECEIVE_LOGIN_QRCODE:
            handleReceiveLoginQRCode(
              data as WhatsAppReceiveLoginQRCodeData,
              client_id,
              ip
            );
            break;
          case WHATSAPP_WS_RESPONSE_TYPE.LOGIN_SUCCESS:
            handleLoginSuccess(data as WhatsAppLoginSuccessData);
            break;
          case WHATSAPP_WS_RESPONSE_TYPE.LOGIN_OUT:
          case WHATSAPP_WS_RESPONSE_TYPE.CLIENT_CLOSE: {
            handleLogout(user_id, data?.quit_reason);
            break;
          }
          case WHATSAPP_WS_RESPONSE_TYPE.RECEIVE_MESSAGE:
          case WHATSAPP_WS_RESPONSE_TYPE.OTHER_TERMINAL_RECEIVE_MESSAGE:
          case WHATSAPP_WS_RESPONSE_TYPE.FILE_DOWNLOAD_SUCCESS_NOTICE: {
            handleReceiveMessage(data as WhatsAppMessageType, user_id);
            break;
          }
          case WHATSAPP_WS_RESPONSE_TYPE.CONVERSATION_CHANGE: {
            handleConversationChange(data as WhatsAppConversationDataType);
            break;
          }
          case WHATSAPP_WS_RESPONSE_TYPE.GET_CONTACT_DETAIL: {
            handleGetContactDetail(data as WhatsAppContact, user_id);
            break;
          }
          case WHATSAPP_WS_RESPONSE_TYPE.UNREAD_NUM_UPDATE: {
            handleUnreadNumUpdate(data as WhatsAppUnreadNumUpdateData);
            break;
          }
          case WHATSAPP_WS_RESPONSE_TYPE.ERROR: {
            handleError(data as WhatsAppErrorData);
            break;
          }
        }
      }
      handlePopWaitWorks();
    },
    { timeout: 100 }
  );
}
handlePopWaitWorks();

/** 接收登录二维码信息（扫码字符串，由页面 QRCode 组件编码展示） **/
function handleReceiveLoginQRCode(
  data: WhatsAppReceiveLoginQRCodeData,
  client_id: number,
  ip?: string
) {
  // 后端推送的是 WhatsApp 配对字符串，不是 PNG base64；原样透传给页面生成二维码
  const url = data?.login_qrcode_path || "";
  chatSdkHooks.common.receiveLoginQRCodeHook.emit({
    channelType: ChannelTypeEnum.WhatsApp,
    data: {
      login_qrcode_key: data?.login_qrcode_key || data?.request_key || "",
      ip: ip || data?.ip,
      client_id: client_id || data?.client_id || data?.clientId,
      url,
    },
  });
}

/** 登录成功之后将用户信息存放到db */
function handleLoginSuccess(data: WhatsAppLoginSuccessData) {
  chatSdkHooks.common.loginSuccessHook.emit({
    channelType: ChannelTypeEnum.WhatsApp,
    user_id: data?.user_id,
  });
}

function handleLogout(user_id: string, quit_reason: string = "") {
  chatSdkHooks.common.logoutHook.emit({
    channelType: ChannelTypeEnum.WhatsApp,
    user_id,
    quit_reason,
  });
}

/** 处理接收到的最新联系人信息 */
function handleGetContactDetail(data: WhatsAppContact, from_user_id: string) {
  chatSdkHooks.whatsapp.getContactDetailHook.emit({
    ...data,
    from_user_id,
    id: `${from_user_id}_${data.user_id}`,
  });
}

/** 监听接收到的消息 */
function handleReceiveMessage(data: WhatsAppMessageType, from_user_id: string) {
  chatSdkHooks.whatsapp.receiveMessageHook.emit({
    ...data,
    from_user_id,
    sending_status: SendingStatus.SUCCESS,
  });
}

/** 处理会话变更 */
function handleConversationChange(data: WhatsAppConversationDataType) {
  chatSdkHooks.whatsapp.conversationChangeHook.emit(data);
}

function handleUnreadNumUpdate(data: WhatsAppUnreadNumUpdateData) {
  chatSdkHooks.whatsapp.unreadNumUpdateHook.emit(data);
}

function handleError(data: WhatsAppErrorData) {
  chatSdkHooks.common.wsErrorHook.emit({
    channelType: ChannelTypeEnum.WhatsApp,
    message: data.error_msg,
  });
}
